import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, TextField, Grid, Typography, Tooltip,
         Table, TableBody, TableCell, TableHead, TableRow} from '@mui/material';
import BindCardPresentmentII from './BindCardPresentmentII';
import BindCardAuthReasonUpdateMutation from './BindCardAuthReasonUpdateMutation';
import ResetBindCardTransactionMutation from './ResetBindCardTransactionMutation';
import ConfirmationDialog from '../ui/ConfirmationDialog';

import EnvironmentDefs from '../../EnvironmentDefs';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';

const envDefs = new EnvironmentDefs();

const abEnvironment = new AbEnvironment();
const BindCardSummaryQuery = graphql`
query BindCardSummaryQuery($bcId: UUID!) {
  bindCardTByBcId(bcId: $bcId) {
    bcId
    extBcId
    firstName
    lastName
    address1
    address2
    city
    state
    country
    postalCode
    accountTByProvisioningAccountId {
      accountName
    }
    accountTByUsingAccountId {
      accountName
    }
    customerAppTsByBcId {
      nodes {
        customerAppId
        appStatus
        marqetaMid
        marqetaMname
        appTByAppId {
          appName
          appSku
          appTByOemAppId {
            appSkuPrice
            marqetaMid
            marqetaMname
          }
        }
      }
    }
    ledgerTByLedgerId {
      ledgerLineTsByLedgerId(condition: {changeType: 1}) {
        nodes {
          changeType
          changeAmount
          transactionTByTransactionId {
            extTransactionId
            transactionTime
          }
        }
      }
    }
    bindCardAuthTsByBcId {
      totalCount
      nodes {
        extMessageId
        extTransactionId
      }
    }
    bindCardExpTsByBcId {
      totalCount
      nodes {
        extBcId
      }
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      // marginTop: 10,
    },
    tabroot: {
      flexGrow: 1,
      margin: 10,
      width: '100%',
    },
    flex: {
      flex: 1,
      textAlign: 'center',
    },
    paper1: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    paper2: {
      padding: 12,
      textAlign: 'left',
      color: theme.palette.text.secondary,
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    formControl: {
      margin: 'theme.spacing(1)',
    },
    textField: {
      margin: 'theme.spacing(1)',
      marginBottom: 6,
    },
    textFieldAddress: {
      margin: 'theme.spacing(1)',
    },
    titleContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    statusdiv: {
      display: 'flex',
      alignItems: 'center',
      direction: 'row',
      justify: 'center',
    },
    statusicon: {
      width: 52,
      height: 52,
      color: 'green',
    },
    erroricon: {
      width: 52,
      height: 52,
      color: 'red',
    },
});

class BindCardSummary extends Component {
    constructor(props) {
        super(props);
        
        let tDate = new Date();
        let theMonthN = tDate.getMonth() + 1;
        let theMonth = "" + theMonthN;
        if (theMonth.length === 1)
            theMonth = "0" + theMonth;
        
        let theDayN = tDate.getDate();
        let theDay = "" + theDayN;
        if (theDay.length === 1)
            theDay = "0" + theDay;

        let formattedDate = "" + tDate.getFullYear() + "-" +
        theMonth + "-" +
        theDay;

        this.state = {
            appName:    null,
            mid:        null,
            mname:      null,
            mcc:        '7372',
            reseller:   null,
            customer:   null,
            firstName:  null,
            lastName:   null,
            address1:   null,
            address2:   null,
            city:       null,
            state:      null,
            country:    'USA',
            postalCode: null,
            billAmt:    0.00,
            cvv:        '000',
            expiration: '0000',
            transdate:  formattedDate,
            theStatus:  'Ready',    
            confirmRotate: false,
            midUpdate:   null,
            mnameUpdate: null,
        }
    }

    getValueForUse(state_member, prop_member, theDefault)
    {
      if (state_member != null)
        return state_member;
      
      if (prop_member != null)
        return prop_member;
  
      return theDefault;
    }

    stripWildcardIfNeeded(prop) {
      let temp = prop;
      if (temp.startsWith('%')) {
        temp = temp.substring(1, temp.length);
      }
      if (temp.endsWith('%')) {
        temp = temp.substring(0, temp.length - 1);
      }
      return temp;
    }

    getMarqetaMid(prop) {
      if (prop.marqetaMid) {
        let nameArr = prop.marqetaMid.split(',');
        return this.stripWildcardIfNeeded(nameArr[0]);
      } else {
        //no value on customer app t.  see if same on app t
        if (prop.appTByAppId.appTByOemAppId && prop.appTByAppId.appTByOemAppId.marqetaMid) {
          let nameArr = prop.appTByAppId.appTByOemAppId.marqetaMid.split(',');
          return this.stripWildcardIfNeeded(nameArr[0]);
        } else {
          return '';
        }
      }
    }

    getMarqetaMname(prop) {
      if (prop.marqetaMname) {
        var nameArr = prop.marqetaMname.split(',');
        return this.stripWildcardIfNeeded(nameArr[0]);
      } else {
        //no value on customer app t.  see if same on app t
        if (prop.appTByAppId.appTByOemAppId && prop.appTByAppId.appTByOemAppId.marqetaMname) {
          let nameArr = prop.appTByAppId.appTByOemAppId.marqetaMname.split(',');
          return this.stripWildcardIfNeeded(nameArr[0]);
        } else {
          return '';
        }      
      }

    }

    getValueForUseNumeric(state_member, prop_member, theDefault)
    {
      if (state_member != null)
      {
        if (state_member === 0 && prop_member != null)
        {
          return prop_member;
        }
        return state_member;
      }
      
      if (prop_member != null)
        return prop_member;
  
      return theDefault;
    }

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve();
            })
        })
    }

    goBack() {
      this.props.history.goBack();
    }

    resetTestim(bcId) {
      ResetBindCardTransactionMutation.commit(bcId)
      .then((resp) => {
        console.log(JSON.stringify(resp));
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        window.location.reload();
      });
    }

    render() {
        const { isAuthenticatedAppBind, logError } = this.props.auth;
        const classes = this.props.classes;
        const params = new URLSearchParams(this.props.location.search);
        let bindcardId = params.get('bcId');

        if (isAuthenticatedAppBind()) {
          return (
            <QueryRenderer
              environment={abEnvironment.getEnvironment()}
              query={BindCardSummaryQuery}
              variables={{bcId: bindcardId}}
              render={({error, props})=> {
                if (error) {
                  logError(error.message);
                  return (
                    <ServerError/>
                  );
                } else if (props) {
                  let extBcId = props.bindCardTByBcId.extBcId;
                  let appStatus = props.bindCardTByBcId.customerAppTsByBcId.nodes[0].appStatus

                  let theTitle = "App: " + props.bindCardTByBcId.customerAppTsByBcId.nodes[0].appTByAppId.appName +
                                 ", Reseller: " + props.bindCardTByBcId.accountTByProvisioningAccountId.accountName +
                                 ", Customer: " + props.bindCardTByBcId.accountTByUsingAccountId.accountName;

                  let isTestimReseller = false;
                  if (props.bindCardTByBcId.accountTByProvisioningAccountId.accountName === 'Testim Reseller Financial') {
                    isTestimReseller = true;
                  }

                  let theNodes = [];
                  props.bindCardTByBcId.ledgerTByLedgerId.ledgerLineTsByLedgerId.nodes.forEach(n => {
                    var anObj = {
                        billAmt: n.changeAmount,
                        tranTime: n.transactionTByTransactionId.transactionTime
                    };
                    theNodes.push(anObj);
                  });

                  theNodes.sort(function(a, b) {
                     a = new Date(a.tranTime);
                     b = new Date(b.tranTime);
                     return a>b ? -1 : a<b ? 1: 0; 
                  });

                  let oemApp = props.bindCardTByBcId.customerAppTsByBcId.nodes[0].appTByAppId.appTByOemAppId;
                  let propPrice = 0;
                  if (oemApp != null)
                  {
                    propPrice = oemApp.appSkuPrice;
                  }

                  let cardToken = props.bindCardTByBcId.extBcId;

                  let expNodes = null;
                  if (props.bindCardTByBcId.bindCardExpTsByBcId.totalCount > 0) {
                    expNodes = props.bindCardTByBcId.bindCardExpTsByBcId.nodes;
                  }

                  return(
                    <div className={classes.root}>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={11}>
                          <Typography variant="subtitle1" className={classes.flex}>
                            {theTitle}
                          </Typography>
                        </Grid>
                        <Grid item xs={1}>
                          <Button color="primary" variant="contained" onClick={() => {this.goBack();}}>
                            Back
                          </Button>
                        </Grid>
                        <Grid item xs={12}/>
                        <Grid item xs={12}/>
                      </Grid>
                      <Grid container spacing={2} justifyContent="space-around">
                        <Grid item xs={6}>
                          <Grid container spacing={2} justifyContent="space-around">
                            <Grid item xs={12}>
                              <BindCardPresentmentII auth={this.props.auth} bcId={bindcardId} cardToken={cardToken}/>
                            </Grid>
                            <Grid item xs={3}>
                                  <TextField
                                    id="mid" label="Merchant ID" className={classes.textField}
                                    value={ this.getValueForUse(this.state.midUpdate, props.bindCardTByBcId.customerAppTsByBcId.nodes[0].marqetaMid, '') }
                                    onChange={ (e) => this.setState({ midUpdate: e.target.value }) }
                                  />
                                </Grid>
                            <Grid item xs={3}>
                              <TextField
                                id="mname" label="Merchant name" className={classes.textField}
                                value={ this.getValueForUse(this.state.mnameUpdate, props.bindCardTByBcId.customerAppTsByBcId.nodes[0].marqetaMname, '') }
                                onChange={ (e) => this.setState({ mnameUpdate: e.target.value }) }
                              />
                            </Grid>
                            <Grid item xs={3}>
                              <Button style={{marginTop: 12}} variant="outlined" disabled={(this.state.midUpdate === null && this.state.mnameUpdate === null)} onClick={() => { this.saveMarqetaInfo(props.bindCardTByBcId.customerAppTsByBcId.nodes[0].customerAppId); }}>Save</Button>
                            </Grid>
                            <Grid item xs={3}>
                            </Grid>
                          
                          </Grid>
                        </Grid>

                        <Grid item xs={6}>
                          <Grid container spacing={2} justifyContent="flex-start">
                            <Grid item xs={3}>
                              <TextField
                                id="mid" label="Merchant ID" className={classes.textField}
                                value={ this.getValueForUse(this.state.mid, this.getMarqetaMid(props.bindCardTByBcId.customerAppTsByBcId.nodes[0]), '') }
                                onChange={ (e) => this.setState({ mid: e.target.value }) }
                              />
                            </Grid>
                            <Grid item xs={3}>
                              <TextField
                                id="mname" label="Merchant name" className={classes.textField}
                                value={ this.getValueForUse(this.state.mname, this.getMarqetaMname(props.bindCardTByBcId.customerAppTsByBcId.nodes[0]), '') }
                                onChange={ (e) => this.setState({ mname: e.target.value }) }
                              />
                            </Grid>
                            <Grid item xs={3}>
                              <TextField
                                id="mcc" label="MCC" className={classes.textField}
                                value={ this.getValueForUse(this.state.mcc, '7372', '7372') }
                                onChange={ (e) => this.setState({ mcc: e.target.value }) }
                              />
                            </Grid>
                            <Grid item xs={3}>
                              <TextField
                                id="mcountry" label="Merchant country" className={classes.textField}
                                value={ this.getValueForUse(this.state.country, 'USA', 'USA') }
                                onChange={ (e) => this.setState({ country: e.target.value }) }
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextField
                                id="first-name" label="First name" className={classes.textField}
                                value={ this.getValueForUse(this.state.firstName, props.bindCardTByBcId.firstName, '') }
                                onChange={ (e) => this.setState({ firstName: e.target.value }) }
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextField
                                id="last-name" label="Last name" className={classes.textField}
                                value={ this.getValueForUse(this.state.lastName, props.bindCardTByBcId.lastName, '') }
                                onChange={ (e) => this.setState({ lastName: e.target.value }) }
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextField
                                id="postal-code" label="Postal code" className={classes.textField}
                                value={ this.getValueForUse(this.state.postalCode, props.bindCardTByBcId.postalCode, '') }
                                onChange={ (e) => this.setState({ postalCode: e.target.value }) }
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextField
                                id="billAmt" label="Billing amount" className={classes.textField}
                                value={ this.getValueForUseNumeric(this.state.billAmt, propPrice, 0) }
                                onChange={ (e) => this.setState({ billAmt: e.target.value }) }
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextField
                                id="cvv" label="CVV" className={classes.textField}
                                value={ this.state.cvv }
                                onChange={ (e) => this.setState({ cvv: e.target.value }) }
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextField
                                id="expiration" label="Expiration" className={classes.textField}
                                value={ this.state.expiration }
                                onChange={ (e) => this.setState({ expiration: e.target.value }) }
                              />
                            </Grid>
                            <Grid item xs={3}>
                              <TextField
                                id="transactionDate" label="Transaction date" className={classes.textField}
                                value={ this.state.transdate }
                                onChange={ (e) => this.setState({ transdate: e.target.value }) }
                              />
                            </Grid>
                            { (envDefs.getEnv() === "poc" || envDefs.getEnv() === "devpoc") &&
                            <React.Fragment>
                              <Grid item xs={12}/>
                              <Grid item>
                                <Tooltip placement='bottom' title='Simulate merchant billing, as well as clearing and charging for the subscription.'>
                                  <Button variant="outlined" onClick={() => { this.billBindCard(bindcardId, extBcId, props, 1); }}>Bill Bindcard</Button>
                                </Tooltip>
                              </Grid>
                              <Grid item>
                                <Tooltip placement='bottom' title="Simulate merchant billing, but don't simulate clearing.  This will show up as a pending charge in statements.">
                                  <Button variant="outlined" onClick={() => { this.billBindCard(bindcardId, extBcId, props, 0); }}>Bill Bindcard (0)</Button>
                                </Tooltip>
                              </Grid>
                              <Grid item>
                                <Tooltip placement='bottom' title="Simulate merchant billing and clearing, but don't charge for the subscription.  Billing buttons will show up on the bctransactions page.">
                                  <Button variant="outlined" onClick={() => { this.billBindCard(bindcardId, extBcId, props, 2); }}>Bill Bindcard (2)</Button>
                                </Tooltip>
                              </Grid>
                              <Grid item>
                                <Button variant="outlined" onClick={() => { this.refundBindCard(props); }}>Refund</Button>
                              </Grid>
                              {isTestimReseller && 
                              <Grid item >
                                <Button color="primary" variant="outlined" onClick={() => {this.resetTestim(bindcardId);}}>
                                  Reset
                                </Button>
                              </Grid>}
                            </React.Fragment>}
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <Button color="primary" variant="outlined" disabled={appStatus !== 0} onClick={() => { this.setState({ confirmRotate: true }); }}>
                            Rotate
                          </Button>
                        </Grid>

                        {/* Rotated cards */}
                        { expNodes != null &&
                        <React.Fragment>
                          <Grid item xs={12}>
                            Rotated cards
                          </Grid>
                          {expNodes.map(n => {
                            return (
                              <React.Fragment key={n.extBcId}>
                                <Grid item xs={6}>
                                  <BindCardPresentmentII auth={this.props.auth} bcId={bindcardId} cardToken={n.extBcId} showCopyButtons={false}/>
                                </Grid>
                                { (envDefs.getEnv() === "poc" || envDefs.getEnv() === "devpoc") &&
                                <Grid item xs={6}>
                                  <Grid container spacing={2} justifyContent="flex-start">

                                    <Grid item>
                                      <Tooltip placement='bottom' title='Simulate merchant billing, as well as clearing and charging for the subscription.'>
                                        <Button variant="outlined" onClick={() => { this.billBindCard(bindcardId, extBcId, props, 1); }}>Bill Bindcard</Button>
                                      </Tooltip>
                                    </Grid>
                                    <Grid item>
                                      <Tooltip placement='bottom' title="Simulate merchant billing, but don't simulate clearing.  This will show up as a pending charge in statements.">
                                        <Button variant="outlined" onClick={() => { this.billBindCard(bindcardId, extBcId, props, 0); }}>Bill Bindcard (0)</Button>
                                      </Tooltip>
                                    </Grid>
                                    <Grid item>
                                      <Tooltip placement='bottom' title="Simulate merchant billing and clearing, but don't charge for the subscription.  Billing buttons will show up on the bctransactions page.">
                                        <Button variant="outlined" onClick={() => { this.billBindCard(bindcardId, extBcId, props, 2); }}>Bill Bindcard (2)</Button>
                                      </Tooltip>
                                    </Grid>
                                    <Grid item>
                                      <Button variant="outlined" onClick={() => { this.refundBindCard(props); }}>Refund</Button>
                                    </Grid>
                                  </Grid>
                                </Grid>}
                              </React.Fragment>
                            );
                          })}                   
                        </React.Fragment>}
                        
                        <Grid item xs={12}/>
                      </Grid>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12}>
                          <Typography variant="subtitle1" className={classes.flex}>
                            {this.state.theStatus}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Transaction date</TableCell>
                            <TableCell>Transaction amount</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {theNodes.map(n => {
                            return (
                              <TableRow key={n.tranTime}>
                                <TableCell>{n.tranTime}</TableCell>
                                <TableCell>{n.billAmt}</TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                      <ConfirmationDialog
                        open={this.state.confirmRotate}
                        onClose={() => { this.setState({confirmRotate:false});}}
                        onConfirm={() => {this.rotate(bindcardId)}}
                        onCancel={() => { }}
                        title="Rotate card?"
                        cancelBtn="No"
                        okBtn="Yes, rotate"
                        irreversibleAction={true}
                      >
                          This will issue a new Marqeta virtual card and associate it with this bindcard / subscription entry. In production, the reseller
                          will need to enter new card details in the app that the card pays for. Are you sure you wish to rotate this card? 
                      </ConfirmationDialog>
                    </div>
                  );
                }
                return <div><LoadingSpinner/></div>
              }}
            />
          );
              
        } else {
          return (
            <Redirect to='/home' />
          );
        }    
    }

    rotate(bindcardId) {

      //alert(bindcardId);
      //return;

      // Call Marqeta to simulate a bindcard refund transaction
      const { callPartnerApi } = this.props.auth;


      let payload = {
        operation: "rotateBindcard",
        params: {
          bcId: bindcardId
        }
      };

      callPartnerApi('appbind/generic',
        'POST',
        payload)
      .then((response) => {
        return response.json();
      }).then((data) => {
        window.location.reload();
      }).catch(error => {
        let errMesg = "Error: " + error;
        this.setState({theStatus: errMesg});
        // console.log(error);
      });

  }


    refundBindCard(theProps) {
        // Call Marqeta to simulate a bindcard refund transaction
        const { callPartnerApi } = this.props.auth;
        const { billAmt } = this.state;
  
        let oemApp = theProps.bindCardTByBcId.customerAppTsByBcId.nodes[0].appTByAppId.appTByOemAppId;
        let propPrice = 0;
        if (oemApp != null)
        {
          propPrice = oemApp.appSkuPrice;
        }
        let theRefundAmt = this.getValueForUseNumeric(billAmt, propPrice, 0);

        let transactionToken = null;
        // Lookup a transaction token based on the transactions that have been made.  If there
        // are none, no refund.  Doesn't matter which one, just take the first.
        let theAuthCount = theProps.bindCardTByBcId.bindCardAuthTsByBcId.totalCount;
        if (theAuthCount > 0) {
          transactionToken = theProps.bindCardTByBcId.bindCardAuthTsByBcId.nodes[0].extMessageId;
        }

        let payload = {
          operation: "simulateBindCardClearing",
          params: {
            bcId: theProps.bindCardTByBcId.bcId,
            ttoken: transactionToken,
            amount: theRefundAmt,
            is_refund: true,
            'sendWebhook': 1
          }
        };

        if (transactionToken != null) {
           callPartnerApi('appbind/generic',
              'POST',
              payload)
          .then((response) => {
            return response.json();
          }).then((data) => {
            this.setState({theStatus: "Ready"});
          }).catch(error => {
            let errMesg = "Error: " + error;
            this.setState({theStatus: errMesg});
            // console.log(error);
          });
        } else {
          this.setState({theStatus: "Nothing to refund"});
        }
    }

    billBindCard(bcId, extBcId, theProps, sendWebhook) {
        // Call Marqeta to simulate a bindcard billing transaction
        const { callPartnerApi } = this.props.auth;
        const { mid, mname, mcc, country, firstName, lastName, postalCode, billAmt, cvv, expiration, transdate } = this.state;
  
        let theMid        = this.getValueForUse(mid, this.getMarqetaMid(theProps.bindCardTByBcId.customerAppTsByBcId.nodes[0]), '');
        let theMName      = this.getValueForUse(mname, this.getMarqetaMname(theProps.bindCardTByBcId.customerAppTsByBcId.nodes[0]), '');
        let theMcc        = this.getValueForUse(mcc, '7372', '');
        let theFirstName  = this.getValueForUse(firstName, theProps.bindCardTByBcId.firstName, '');
        let theLastName   = this.getValueForUse(lastName, theProps.bindCardTByBcId.lastName, '');
        let thePostalCode = this.getValueForUse(postalCode, theProps.bindCardTByBcId.postalCode, '');

        let oemApp = theProps.bindCardTByBcId.customerAppTsByBcId.nodes[0].appTByAppId.appTByOemAppId;
        let propPrice = 0;
        if (oemApp != null)
        {
          propPrice = oemApp.appSkuPrice;
        }
        let theBillAmt = this.getValueForUseNumeric(billAmt, propPrice, 0);

        let methodState = "Start";
        let transactionToken = null;

        let theCountry = country;
        if (theCountry == null) {
          theCountry = 'USA';
        }

        let payload = {
          operation: "simulateBindCardAuthorization",
          params: {
            bcId: bcId,
            extBcId: extBcId,
            mid: theMid,
            mname: theMName,
            mcc: theMcc,
            country: theCountry,
            amount: theBillAmt,
            firstName: theFirstName,
            lastName: theLastName,
            postalCode: thePostalCode,
            cvv: cvv,
            expiration: expiration          
          }
        };

        this.promisedSetState({theStatus: "Billing..."})
        .then(() => {
          // Call backend to auth and clear, get returned transaction value (via server API)
          return callPartnerApi('appbind/generic',
                   'POST',
                   payload
              );
        }).then(response => {
          return response.json();
        }).then(theResponse => {
          if (theResponse.status !== 0) {
            // Some error occurred, treat as declined
            methodState = "Declined";
            return this.promisedSetState({theStatus: "Charge Declined"});
          }

          let data = theResponse.resp;

          // Was the auth accepted?
          if (data.transaction.state != null &&
              data.transaction.state === 'PENDING')
          {
            methodState = "Clearing";
            transactionToken = data.transaction.token;
            // Call mutation to set transaction time
            let theTransdate = transdate;
            if (sendWebhook === 2) {
              theTransdate = theTransdate + '|nc';
            }
            
            return BindCardAuthReasonUpdateMutation.commit(bcId, 'marqeta', data.transaction.gpa_order.jit_funding.token, theTransdate);
            //return data;
          }
          else
          {
            methodState = "Declined";
            return this.promisedSetState({theStatus: "Charge Declined"});
          }
        }).then(data => {
          // Was the auth accepted?
          if (methodState === 'Clearing')
          {
            if (sendWebhook == null || sendWebhook === 1 || sendWebhook === 2) {
              let payload2 = {
                operation: "simulateBindCardClearing",
                params: {
                  bcId: bcId,
                  ttoken: transactionToken,
                  amount: theBillAmt,
                  'sendWebhook': 1
                }
              };

              return callPartnerApi('appbind/generic',
                  'POST',
                  payload2
              );
            } else {
              let payload2 = {
                operation: "simulateBindCardClearing",
                params: {
                  bcId: bcId,
                  ttoken: transactionToken,
                  amount: theBillAmt,
                  'sendWebhook': 0
                }
              };
  
              return callPartnerApi('appbind/generic',
                  'POST',
                  payload2
              );
            }
          }
          else
          {
            return data;
          }
        }).then((response) => {
          if (methodState === 'Clearing')
            return response.json();
          else
            return response;
        }).then((data) => {
          if (methodState === 'Clearing')
          {
            // Do something with the returned data - check
            // to make sure all is well.

            // Then, set state to ready
            return this.promisedSetState({theStatus: "Ready"});
          }
          else if (methodState === "Declined") {
            return;
          } else {
            // Should this ever happen?
            return this.promisedSetState({theStatus: "Ready"});
          }
        }).catch(error => {
          let errMesg = "Error: " + error;
          this.setState({theStatus: errMesg});
          // console.log(error);
        });
    }

    saveMarqetaInfo(customerAppId) {
      // Call API to update customer app info
      const { callPartnerApi } = this.props.auth;
      const { midUpdate, mnameUpdate } = this.state;


      let payload = {
        operation: "updateMarqetaInfo",
        params: {
          customerAppId: customerAppId,
          marqetaMid: midUpdate,
          marqetaMname: mnameUpdate      
        }
      };


      callPartnerApi('appbind/generic',
      'POST',
      payload)
      .then(resp => {
        window.location.reload();
      })
      .catch(resp => {
        window.location.reload();
      })
  }
}

BindCardSummary.propTypes = {
    classes: PropTypes.object.isRequired,
  };
        
export default withStyles(styleSheet)(BindCardSummary);
  